const constants = {
    get CONTACT_OO() {
        return "Neem contact op met <a href='https://oudersenonderwijs.nl/contact/' target=_blank>Ouders & Onderwijs</a> voor hulp of meer informatie.";
    },
};

export default constants;
